export default "__VITE_ASSET__DhgM1L4a__"